export const SET_CUSTOM_FRAMEWORK_DETAILS = "SET_CUSTOM_FRAMEWORK_DETAILS";
